import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['key', 'point', 'tooltip']

  disconnect () {
    this.cancelHide()
    this.clearActivePoint()
  }

  show (event) {
    this.cancelHide()

    const index = event.currentTarget.dataset.pointIndex
    const point = this.pointTargets.find(candidate => candidate.dataset.pointIndex === index)
    if (!point) return

    if (this.activeIndex !== index) {
      this.pointTargets.forEach(candidate => candidate.classList.toggle('is-active', candidate === point))
      this.keyTargets.forEach(candidate => candidate.classList.toggle('is-active', candidate.dataset.pointIndex === index))
      this.element.classList.add('has-active-point')
      point.parentNode.appendChild(point)
      this.renderTooltip(point)
      this.activeIndex = index
    }

    this.positionTooltip(point)
  }

  hide () {
    this.cancelHide()
    this.hideTimer = window.setTimeout(() => this.clearActivePoint(), 100)
  }

  dismiss (event) {
    if (event.key !== 'Escape') return

    this.clearActivePoint()
    event.target.blur?.()
  }

  clearActivePoint () {
    this.cancelHide()
    this.activeIndex = null
    this.element.classList.remove('has-active-point')
    this.pointTargets.forEach(point => point.classList.remove('is-active'))
    this.keyTargets.forEach(key => key.classList.remove('is-active'))

    if (this.hasTooltipTarget) this.tooltipTarget.hidden = true
  }

  renderTooltip (point) {
    const heading = document.createElement('div')
    heading.className = 'year-end-scatter-tooltip-heading'

    const number = document.createElement('span')
    number.textContent = point.dataset.pointNumber

    const title = document.createElement('div')
    const primary = document.createElement('strong')
    primary.textContent = point.dataset.title
    const secondary = document.createElement('small')
    secondary.textContent = point.dataset.subtitle
    title.append(primary, secondary)
    heading.append(number, title)

    const metrics = document.createElement('div')
    metrics.className = 'year-end-scatter-tooltip-metrics'
    metrics.append(
      this.metric('Total visitors', point.dataset.visitors),
      this.metric('Dwell', point.dataset.dwell),
      this.metric('Conversion', point.dataset.conversion)
    )

    this.tooltipTarget.replaceChildren(heading, metrics)
    this.tooltipTarget.hidden = false
  }

  metric (label, value) {
    const metric = document.createElement('span')
    const name = document.createElement('small')
    name.textContent = label
    const result = document.createElement('strong')
    result.textContent = value
    metric.append(name, result)
    return metric
  }

  positionTooltip (point) {
    const container = this.element.getBoundingClientRect()
    const pointBounds = point.getBoundingClientRect()
    const x = pointBounds.left + (pointBounds.width / 2)
    const y = pointBounds.top
    const offset = 14
    const padding = 8
    const tooltip = this.tooltipTarget
    const tooltipBounds = tooltip.getBoundingClientRect()

    let left = x - container.left + offset
    if (left + tooltipBounds.width > container.width - padding) {
      left = x - container.left - tooltipBounds.width - offset
    }
    left = Math.max(padding, left)

    let top = y - container.top - tooltipBounds.height - offset
    if (top < padding) top = y - container.top + offset

    tooltip.style.left = `${left}px`
    tooltip.style.top = `${top}px`
  }

  cancelHide () {
    if (!this.hideTimer) return

    window.clearTimeout(this.hideTimer)
    this.hideTimer = null
  }
}
